"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectors = tslib_1.__importStar(require("../selectors"));
var clientSelectors = tslib_1.__importStar(require("../../client/selectors"));
var translationsSelectors = tslib_1.__importStar(require("../../translations/selectors"));
var intl_format_1 = require("@biw/intl-format");
var constants = tslib_1.__importStar(require("@biw/contests-constants"));
var challengepointCodes = tslib_1.__importStar(require("./challengepoint-codes"));
var goalquestCodes = tslib_1.__importStar(require("./goalquest-codes"));
var managerCodes = tslib_1.__importStar(require("./manager-codes"));
var objectivesCodes = tslib_1.__importStar(require("./objectives-codes"));
var finalResultsProps = function (state, props) {
    if (props === void 0) { props = {}; }
    var _a = props.program || {}, programViewId = _a.programViewId, role = _a.role;
    var resultType = selectors.getResultType(state, programViewId);
    if (!selectors.getProgramViewProgressLastUpdated(state, programViewId)) {
        return {};
    }
    var finalResult = selectors.getProgramViewFinalResults(state, programViewId) || {};
    var mediaLabel = clientSelectors.getMediaLabel(state);
    var locale = translationsSelectors.getUserLocale(state);
    var formatLocaleNumber = function (value) { return intl_format_1.formatNumber(locale, {}, value); };
    var replaceOptions = {
        totalBonusPoints: formatLocaleNumber(finalResult.totalBonusPoints || 0),
        totalBaseEarnings: formatLocaleNumber(selectors.getProgramViewProgressEarnedToDate(state, programViewId)),
        totalPoints: formatLocaleNumber(finalResult.totalNumberOfPoints || 0),
        potentialAward: formatLocaleNumber(finalResult.totalGoalPoints || 0),
        goalPoints: formatLocaleNumber(finalResult.totalGoalPoints || 0),
        bonusPoints: formatLocaleNumber(finalResult.totalBonusPoints || 0),
        levelName: finalResult.levelName || '',
        paxAchievedCount: finalResult.totalNumberofPaxWhoAchievedGoal || 0,
        managerRange: finalResult.managerRange || null,
        mediaLabel: mediaLabel
    };
    var mappedProps = {
        hasResults: !!resultType,
        contentRole: role !== 'Selector' ? 'manager' : 'selector',
        totalPoints: finalResult.totalNumberOfPoints || 0,
        headlineCode: '',
        subheadlineCode: '',
        messageCode: '',
        additionalMessageCode: '',
        replaceOptions: replaceOptions
    };
    var resultCode = selectors.getResultCode(state, programViewId);
    switch (resultType) {
        case 'manager':
            if (!finalResult.isManagerEligibleForAward) {
                return {};
            }
            mappedProps.headlineCode = managerCodes.getHeadline(resultCode);
            mappedProps.subheadlineCode = managerCodes.getSubHeadline(resultCode);
            mappedProps.messageCode = managerCodes.getMessage(resultCode);
            break;
        case constants.PT__GQ:
            mappedProps.headlineCode = goalquestCodes.getHeadline(resultCode);
            mappedProps.subheadlineCode = goalquestCodes.getSubHeadline(resultCode);
            mappedProps.messageCode = goalquestCodes.getMessage(resultCode);
            mappedProps.additionalMessageCode = goalquestCodes.getAdditionalMessage(resultCode);
            break;
        case constants.PT__CP:
            mappedProps.headlineCode = challengepointCodes.getHeadline(resultCode);
            mappedProps.subheadlineCode = challengepointCodes.getSubHeadline(resultCode);
            mappedProps.messageCode = challengepointCodes.getMessage(resultCode);
            break;
        case constants.PT__OBJ:
            mappedProps.headlineCode = objectivesCodes.getHeadline(resultCode);
            mappedProps.subheadlineCode = objectivesCodes.getSubHeadline(resultCode);
            mappedProps.messageCode = objectivesCodes.getMessage(resultCode);
            break;
    }
    return mappedProps;
};
exports.default = finalResultsProps;
//# sourceMappingURL=final-results-props.js.map